var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32346 14.0704C9.74889 12.8908 15.8847 9.93636 21.0245 7.55566M6.26953 11.8988L12.5931 9.72724",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69258 9.67236L21.7586 6.01822C22.7901 5.83038 23.4271 7.13967 22.6638 7.87867L14.1991 16.0738C14.1216 16.1489 14.0355 16.2155 13.9314 16.2384C13.3073 16.3762 11.9315 15.9637 10.5255 15.4203M1 10.3321C1.67677 10.8815 3.12089 11.9018 4.39638 12.39C4.90133 12.5833 5.29672 13.0616 5.2959 13.6165C5.29387 14.9787 5.35843 16.7025 5.58893 17.6701C5.70898 18.174 6.13664 18.0666 6.30782 17.5785C6.34972 17.459 6.39376 17.3317 6.43946 17.1974M6.11216 17.8976L10.5255 15.4203M10.5255 15.4203C10.1586 15.2786 9.78962 15.1279 9.43143 14.9757M6.43946 17.1974L9.9584 15.2292L9.43143 14.9757M6.43946 17.1974C6.50195 17.0137 6.56755 16.817 6.63504 16.6097M9.43143 14.9757L6.63504 16.6097M9.43143 14.9757C9.22926 14.8899 9.03052 14.8035 8.83751 14.718M6.63504 16.6097C6.70506 16.3946 6.77712 16.168 6.84986 15.9326M6.84986 15.9326C6.91296 15.7284 6.97658 15.5176 7.03983 15.3019C7.05488 15.2506 7.07314 15.2012 7.0943 15.1539M6.84986 15.9326L8.83751 14.718M8.83751 14.718C8.73738 14.6737 8.63879 14.6296 8.54207 14.5859C8.48789 14.5615 8.43289 14.5419 8.37751 14.527M8.37751 14.527C7.86373 14.3891 7.31747 14.6552 7.0943 15.1539M8.37751 14.527L7.0943 15.1539",
    stroke: "black",
    strokeOpacity: 1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.1094065bca3868bbf430e71324ea1128.svg";
export { ForwardRef as ReactComponent };